import { getCruiseItems, getBookingCabinSelectionData } from 'checkout/selectors/cruiseSelectors'
import CruiseSessionCountdownMessage from 'components/Common/CruiseSessionCountdownClock/CruiseSessionCountdownMessage'
import { shouldRenderCruiseSessionCountdownClock } from 'components/Common/CruiseSessionCountdownClock/utils'
import PageBanner from 'components/Luxkit/Banners/PageBanner'
import { mediaQueryUp } from 'components/utils/breakpoint'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'
import { useAppSelector } from 'hooks/reduxHooks'

const Container = styled.div`
  ${mediaQueryUp.desktop} {
    position: sticky;
    z-index: ${zIndex.stickyHeaderBanner};
    top: ${props => props.theme.layout.headerFloatingOffset};
    right: 0;
    left: 0;
  }

  &:empty {
    display: none;
  }
`

interface MappedStateProps {
  hasCruise: boolean
}

/**
 * Contains high-level banners and elements in the checkout.
 *
 * Becomes sticky on desktop and larger devices.
 */
function CheckoutSubheader(props: MappedStateProps) {
  const { hasCruise } = props
  const match = useRouteMatch<{ step: string }>()
  const cabinSelectionData = useAppSelector((state) => getBookingCabinSelectionData(state))

  const showCruiseSessionCountdownClock = useMemo(() => (
    hasCruise &&
    !cabinSelectionData.loading &&
    shouldRenderCruiseSessionCountdownClock(match.params.step)
  ), [hasCruise, cabinSelectionData, match.params.step])

  return <Container id="checkout-sub-header">
    {showCruiseSessionCountdownClock && <PageBanner
      kind="informational-primary"
      align="center"
      description={<CruiseSessionCountdownMessage />}
    />}
  </Container>
}

export default connect<MappedStateProps, {}, {}, App.State>((state) => {
  return {
    hasCruise: getCruiseItems(state).length > 0,
  }
})(CheckoutSubheader)
